import { getBaseOs } from 'react-native-device-info';
import {
  isAndroid,
  isIOS,
  isIOS13,
  osName,
  osVersion,
} from 'react-device-detect';
import { Firebase, FirebaseRef, TournamentsRef } from '../lib/firebase';
import { size, get } from "lodash";

import { Platform } from 'react-native';

const getDevMode = () => {
  let devMode = false;

  if (window && window.location) {
    const hostname = get(window.location, 'hostname');

    if (hostname === 'inbox.dev.spelezoli.lv' || hostname === 'dra.dev.spelezoli.lv' || hostname === 'dev.spelezoli.lv' || hostname === 'fb.dev.spelezoli.lv' || hostname === 'localhost') {
      devMode = true;
    }
  }
  return devMode;
}

export function getMyTournamentsData() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => TournamentsRef().child(`playerActiveTournamentData/${UID}`)
    .on('value', (snapshot) => {
      const playerData = snapshot.val() || {};

      resolve(dispatch({
        type: 'MY_TOURNAMENTS_DATA',
        data: playerData,
      }));
    }));
}


export function getTournamentsOld(devMode) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => TournamentsRef().child('newTournamentsList')
    .orderByChild('open')
    .equalTo(true)
    .on('value', (snapshot) => {
      let data = snapshot.val() || {};

      console.log('getTournaments', data);
      FirebaseRef.child(`users/${UID}`)
        .once('value', (playerSnapshot) => {
          const userData = playerSnapshot.val() || {};
          if (!devMode) {
            const dataFiltered = {};
            Object.keys(data).map((key) => {
              if (data[key] && (data[key].devTournament !== true || devMode)) {
                dataFiltered[key] = { ...data[key] };
              }
              return null;
            });

            data = { ...dataFiltered };
          }

          return resolve(dispatch({ type: 'TOURNAMENTS_REPLACE', data, userData }));
        });
    })).catch((err) => { console.log(err.message); });
}

export function getTournaments(devMode) {

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  TournamentsRef().child('newTournamentsList').off();

  return dispatch => new Promise(resolve => TournamentsRef().child('newTournamentsList')
    .orderByChild('open')
    .equalTo(true)
    .once('value', (snapshot) => {
      let data = snapshot.val() || {};


      FirebaseRef.child(`users/${UID}`)
        .once('value', (playerSnapshot) => {
          const userData = playerSnapshot.val() || {};
          if (!devMode) {
            const dataFiltered = {};
            Object.keys(data).map((key) => {
              if (data[key] && (data[key].devTournament !== true || devMode)) {
                dataFiltered[key] = { ...data[key] };
              }
              return null;
            });

            data = { ...dataFiltered };
          }

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_added', (snapshot2) => {
              let childAddedData = snapshot2.val() || {};
              const childAddedKey = snapshot2.key;

              if (devMode || (!devMode && childAddedData.devTournament !== true)) {
                dispatch({ type: 'TOURNAMENTS_CHILD_ADDED', data: childAddedData, childAddedKey, userData });
              }
            });

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_changed', (snapshot2) => {
              let childChangedData = snapshot2.val() || {};
              const childChangedKey = snapshot2.key;

              if (devMode || (!devMode && childChangedData.devTournament !== true)) {
                dispatch({ type: 'TOURNAMENTS_CHILD_CHANGED', data: childChangedData, childChangedKey, userData });
              }
            });

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_removed', (snapshot2) => {
              const childRemovedKey = snapshot2.key;
              dispatch({ type: 'TOURNAMENTS_CHILD_REMOVED', childRemovedKey, userData });
            });

          return resolve(dispatch({ type: 'TOURNAMENTS_REPLACE', data, userData }));
        });
    })).catch((err) => { console.log(err.message); });
}

export function getTournamentsForMobile(devMode) {

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  TournamentsRef().child('newTournamentsList').off();

  return dispatch => new Promise(resolve => TournamentsRef().child('newTournamentsList')
    .orderByChild('open')
    .equalTo(true)
    .once('value', (snapshot) => {
      let data = snapshot.val() || {};


      FirebaseRef.child(`users/${UID}`)
        .once('value', (playerSnapshot) => {
          const userData = playerSnapshot.val() || {};
          if (!devMode) {
            const dataFiltered = {};
            Object.keys(data).map((key) => {
              if (data[key] && (data[key].devTournament !== true || devMode)) {
                dataFiltered[key] = { ...data[key] };
              }
              return null;
            });

            data = { ...dataFiltered };
          }

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_added', (snapshot2) => {
              let childAddedData = snapshot2.val() || {};
              const childAddedKey = snapshot2.key;

              if (devMode || (!devMode && childAddedData.devTournament !== true)) {
                dispatch({ type: 'TOURNAMENTS_CHILD_ADDED', data: childAddedData, childAddedKey, userData });
              }
            });

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_changed', (snapshot2) => {
              let childChangedData = snapshot2.val() || {};
              const childChangedKey = snapshot2.key;

              if (devMode || (!devMode && childChangedData.devTournament !== true)) {
                dispatch({ type: 'TOURNAMENTS_CHILD_CHANGED', data: childChangedData, childChangedKey, userData });
              }
            });

          TournamentsRef().child('newTournamentsList')
            .orderByChild('open')
            .equalTo(true)
            .on('child_removed', (snapshot2) => {
              const childRemovedKey = snapshot2.key;
              dispatch({ type: 'TOURNAMENTS_CHILD_REMOVED', childRemovedKey, userData });
            });

          return resolve(dispatch({ type: 'TOURNAMENTS_REPLACE_MOBILE', data, userData }));
        });
    })).catch((err) => { console.log(err.message); });
}

export function getTournamentsHistory(devMode) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => TournamentsRef().child('newTournamentsList')
    .orderByChild('open')
    .equalTo(false)
    // .limitToLast(2000)
    .once('value', (snapshot) => {
      let data = snapshot.val() || {};

      if (!devMode) {
        const dataFiltered = {};
        Object.keys(data).map((key) => {
          if (data[key] && (data[key].devTournament !== true || devMode)) {
            dataFiltered[key] = { ...data[key] };
          }
          return null;
        });

        data = { ...dataFiltered };
      }

      const dataArray = Object.entries(data)
        .map(([key, value]) => ({ key, ...value }))
        .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

      return resolve(dispatch({ type: 'TOURNAMENTS_HISTORY_REPLACE', data: dataArray }));
    })).catch((err) => { console.log(err.message); });
}

export function getPlayerTournamentsHistory(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('getPlayerTournamentsHistory', uid);

  return dispatch => new Promise(resolve => TournamentsRef().child(`playerTournamentHistory/${uid}`)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      const dataArray = Object.entries(data).map(([key, value]) => ({ key, ...value }));
      dataArray.sort((a, b) => {
        const aIsRegistration = (a.currentState === 'registration' || a.currentState === 'pause' || a.currentState === 'play');
        const bIsRegistration = (b.currentState === 'registration' || b.currentState === 'pause' || b.currentState === 'play');

        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        return b.startDate - a.startDate;
      });

      return resolve(dispatch({ type: 'PLAYER_TOURNAMENTS_HISTORY_REPLACE', data: dataArray }));
    })).catch((err) => { console.log(err.message); });
}

export function getPlayerTournamentsHistoryMobile(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => TournamentsRef().child(`playerTournamentHistory/${uid}`)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      const dataArray = Object.entries(data).map(([key, value]) => ({ key, ...value }));
      dataArray.sort((a, b) => {
        const aIsRegistration = (a.currentState === 'registration' || a.currentState === 'pause' || a.currentState === 'play');
        const bIsRegistration = (b.currentState === 'registration' || b.currentState === 'pause' || b.currentState === 'play');

        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        return b.startDate - a.startDate;
      });

      return resolve(dispatch({ type: 'PLAYER_TOURNAMENTS_HISTORY_REPLACE_Mobile', data: dataArray }));
    })).catch((err) => { console.log(err.message); });
}


const PAGE_SIZE = 50;

export function getTournamentsHistoryPage(devMode, lastCursor = null) {
  console.log('we are loading history', lastCursor)
  if (Firebase === null) return () => Promise.resolve();

  return dispatch => new Promise((resolve, reject) => {
    // Vienmēr kārtojam pēc createdAt
    let q;
console.log('lastCursor', lastCursor)
console.log('lastCursor', lastCursor)
console.log('lastCursor', lastCursor)
    if (lastCursor == null) {
      // Pirmā lapa: jaunākie 50 līdz tagad
      q = TournamentsRef()
        .child('newTournamentsList')
        .orderByChild('startDate')
        .endAt(Date.now())
        .limitToLast(PAGE_SIZE);
    } else {
      // Nākamā lapa: endAt ir inclusive → ņemam +1 un izmetam dublikātu
      q = TournamentsRef()
        .child('newTournamentsList')
        .orderByChild('startDate')
        .endAt(lastCursor)
        .limitToLast(PAGE_SIZE);
    }

    q.once('value', (snapshot) => {
      const raw = snapshot.val() || {};
      let items = Object.entries(raw).map(([id, data]) => ({
        id,
        ...data,
      }));

// sakārto pēc startAt augošā secībā
      items.sort((a, b) => a.startDate - b.startDate).reverse();

      let arr = items;

      if (lastCursor != null && arr.length && arr[0].startDate === lastCursor) {
        arr.shift();
      }


      if (!devMode) {
        arr = arr.filter(item => item.devTournament !== true);
      }

      // Ja tas ir pirmais pieprasījums → REPLACE, citādi → APPEND

      console.log('arr', arr)
      dispatch({
        type: lastCursor == null ? 'TOURNAMENTS_HISTORY_REPLACE' : 'TOURNAMENTS_HISTORY_APPEND',
        data: arr,
      });

      // Ja atnāca tukšs vai mazāk par PAGE_SIZE, vairs nav nākamās lapas
      const newLastCursor = arr.length ? arr[arr.length - 1].startDate : lastCursor;
      resolve({ data: arr, lastCursor: newLastCursor, fullPage: size(raw) === 50 });
    }, reject);
  }).catch((err) => { console.log(err?.message); return { data: [], lastCursor }; });
}

export function getTournamentPlayers(tournamentId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    const promise1 = TournamentsRef().child(`newTournaments/${tournamentId}/players`).orderByChild('quitBeforeStart').equalTo(null)
      .once('value');
    const promise2 = TournamentsRef().child(`newTournaments/${tournamentId}/playersStaticData`).orderByChild('quitBeforeStart').equalTo(null)
      .once('value');

    Promise.all([promise1, promise2]).then(async (promisesRes) => {
      let playersData;
      let playersStaticData;

      promisesRes.map((promiseRes, index) => {
        if (index === 0) {
          playersData = promiseRes.val() || {};
        } else if (index === 1) {
          playersStaticData = promiseRes.val() || {};
        }

        return null;
      });

      const players = {};

      if (playersStaticData) {
        await Promise.all(Object.keys(playersStaticData).map(async (key) => {
          await FirebaseRef.child(`users/${playersStaticData[key].uid}/bal`)
            .once('value', (snapshot) => {
              const balance = snapshot.val() || 0;

              players[key] = {
                ...playersData[key], ...playersStaticData[key], balance,
              };
              return null;
            });
        }));
      }
      console.log(playersData, playersStaticData, { players }, 'tournaments players');
      return resolve(dispatch({ type: 'TOURNAMENT_PLAYERS_REPLACE', data: players }));
    });
  }).catch((err) => { console.log(err.message); });
}

export function getTournamentActiveRooms(tournamentId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    const promise1 = TournamentsRef().child(`newTournaments/${tournamentId}/currentPlayedRooms`).orderByChild('roomClosed').equalTo(false)
      .once('value');

    Promise.all([promise1]).then((promisesRes) => {
      let currentPlayedRooms;

      promisesRes.map((promiseRes, index) => {
        if (index === 0) {
          currentPlayedRooms = promiseRes.val() || {};
        }
        return null;
      });

      //  console.log('currentPlayedRooms', { currentPlayedRooms });

      return resolve(dispatch({ type: 'TOURNAMENT_CURRENT_ROOMS_REPLACE', data: currentPlayedRooms, tournamentId }));
    });
  }).catch((err) => { console.log(err.message); });
}

export function closeTournamentResults() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    FirebaseRef.child(`users/${UID}/showTournamentResults`).remove().then(() => resolve()).catch(() => resolve());
  }).catch((err) => { console.log(err.message); });
}


/*
export function getTournamentPlayerHistory(tournamentId, playerId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => {

    TournamentsRef().child(`tournamentPlayerHistory/${tournamentId}/players/${playerId}`).once('value', snapshot => {
      const playerHistory = snapshot.val() || null;

      return resolve(dispatch({ type: 'TOURNAMENT_PLAYER_HISTORY', data: playerHistory }));
    });

  }).catch((err) => { console.log(err.message); });
} */

export function joinTournament(tournamentId, passString) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise(resolve => getBaseOs().then((baseOs) => {
    /* let env;
    if (baseOs === 'Windows' || (window && window.document)) {
      env = 'web';
    } else if (isAndroid) {
      env = 'android';
    } else if (isIOS || isIOS13) {
      env = 'ios';
    } else {
      env = 'android';
    } */

    /*
    let env;
    
    if (baseOs === 'Windows' || (window && window.document)) {
      env = 'web';
    } else if (isAndroid) {
      env = 'android';
    } else if (isIOS || isIOS13) {
      env = 'ios';
    } else {
      env = 'android';
    }

    const osNameVal = osName;
    const osVersionVal = osVersion;

    if (osNameVal === 'Android') {
      env = 'android';
    } else if (osNameVal === 'iOS') {
      env = 'ios';
    } else if (osNameVal === 'Windows' || osNameVal === 'Linux') {
      env = 'web';
    } */

    let env;
    if (baseOs === 'Windows' || (window && window.document)) {
      env = 'web';
    } else if (isAndroid) {
      env = 'android';
    } else if (isIOS || isIOS13) {
      env = 'ios';
    } else {
      env = 'web';
    }

    const osNameVal = osName;
    const osVersionVal = osVersion;

    if (baseOs === 'Windows' || (window && window.document)) {
      env = 'web';
    } else if (Platform && Platform.OS === 'Android') {
      env = 'android';
    } else if (Platform && Platform.OS) {
      env = 'ios';
    }

    let devMode = getDevMode();

    const joinTournamentFunction = Firebase.app().functions('europe-west1').httpsCallable('joinTournament');

    joinTournamentFunction({
      tournamentId,
      passString: passString || null,
      env,
      osName: osNameVal || null,
      osVersion: osVersionVal || null,
      isAndroid: isAndroid || null,
      isIOS: isIOS || null,
      baseOs: baseOs || null,
      PlatformOS: (Platform && Platform.OS) ? Platform.OS : null,
    }).then((result) => {
      const { data } = result;
      resolve(data);
    });
  }));
}

export function leaveTournament(tournamentId, leaveReason) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      const leaveTournamentFunction = Firebase.app().functions().httpsCallable('leaveTournament');

      leaveTournamentFunction({
        tournamentId,
        leaveReason,
      }).then((result) => {
        resolve(dispatch({ type: 'LEAVE_TOURNAMENT', data: result }));
      });
    }
  }));
}

export function returnToTournament(tournamentId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    const returnToTournamentFunction = Firebase.app().functions().httpsCallable('returnToTournament');

    returnToTournamentFunction({
      tournamentId,
    }).then((result) => {
      const { data } = result;
      resolve(data);
    }).catch((err) => {
      console.log(err);
      resolve();
    });
  });
}

export function pauseTournament(tournamentId) {
  console.log('pauseTournament', { tournamentId });
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    const pauseTournamentFunction = Firebase.app().functions().httpsCallable('pauseTournament');

    pauseTournamentFunction({
      tournamentId,
    }).then((result) => {
      const { data } = result;
      resolve(data);
    });
  });
}
